export enum AggregationType {
  KEYWORD = 'keyword',
  DATERANGE = 'daterange',
  NUMERIC_RANGE = 'numericrange'
}
